import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import MainTitle from 'base/components/MainTitle/index';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import Title3 from 'base/components/Title3/index';
import { closeModal } from 'modal/store/actions';
import Button from 'base/components/Button/index';
import Col from 'base/components/Col/index';
import Row from 'base/components/Row/index';
import Loader from 'base/components/Loader';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useDeleteContactMutation, useGetContactQuery } from 'contacts/store/contactService';
import toast from 'base/components/Toast/toast';
import { getActiveContactId } from '../../store/selectors';

export default function DeleteContactModal({ name }) {
  const dispatch = useAppDispatch();
  const activeContactId = useAppSelector(getActiveContactId);
  const { data: contact, isLoading } = useGetContactQuery(activeContactId);
  const [deleteContact] = useDeleteContactMutation();
  const handleDelete = useCallback(async () => {
    try {
      await deleteContact(activeContactId).unwrap();
      toast.success('Successfully deleted contact');
    } catch (e) {
      toast.error('Error deleting contact');
    }
    dispatch(closeModal(name));
  }, [activeContactId, deleteContact, dispatch, name]);
  return (
    <>
      <MainTitle withSpaceBelow>Delete Contact</MainTitle>

      <Loader isLoading={isLoading}>
        <>
          <FieldWrapper>
            Do you really want to delete
            <Title3>{contact?.name}</Title3>
          </FieldWrapper>

          <Row>
            <Col>
              <Button isFullWidth variant="secondary" onClick={() => dispatch(closeModal(name))}>
                No, cancel
              </Button>
            </Col>
            <Col>
              <Button isFullWidth variant="primary" onClick={handleDelete}>
                Yes, delete
              </Button>
            </Col>
          </Row>
        </>
      </Loader>
    </>
  );
}
DeleteContactModal.propTypes = {
  name: PropTypes.string.isRequired,
};
